// ENG-3676: kept apart from titleOpensSidePanel so the inbox list code does not
// import the tutorial module (that import closes a dependency cycle through App).

import { readStoredUserEmail, resolveUserKey } from '../components/tutorial/tutorialProgress';

// The one-time tip in the side panel ("Documents now open next to your inbox").
// Seen-state is per user, namespaced by email like the tutorial progress, and kept
// across sign-out (see actions/auth.js#resetAuth) because it records what the user
// has learned.
export const SIDE_PANEL_TIP_SEEN_KEY = 'm8_side_panel_tip_seen_v1';
export const PRESERVED_SIDE_PANEL_TIP_KEYS = new Set([SIDE_PANEL_TIP_SEEN_KEY]);

const readSeenUsers = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(SIDE_PANEL_TIP_SEEN_KEY));
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const hasSeenSidePanelTip = (email = readStoredUserEmail()) => (
  readSeenUsers().includes(resolveUserKey(email))
);

export const markSidePanelTipSeen = (email = readStoredUserEmail()) => {
  const userKey = resolveUserKey(email);
  const seen = readSeenUsers();
  if (seen.includes(userKey)) return;
  try {
    localStorage.setItem(SIDE_PANEL_TIP_SEEN_KEY, JSON.stringify([...seen, userKey]));
  } catch {
    // Nothing to remember it in; the tip may show again.
  }
};
